import script from "./roads.vue?vue&type=script&setup=true&lang=js"
export * from "./roads.vue?vue&type=script&setup=true&lang=js"

import "./roads.vue?vue&type=style&index=0&id=01c65023&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c65023"]])

export default __exports__